import { Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'xp-input-checkbox',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      useExisting: forwardRef(() => XpInputCheckboxComponent),
      multi: true,
    },
  ],
  template: `
    <label class="input-checkbox" [ngClass]="{ disabled: disabled }">
      <i class="fa" [ngClass]="{ 'fa-square-o': !checked, 'fa-check-square': checked }"></i>
      <input
        [attr.name]="name"
        type="checkbox"
        [(ngModel)]="checked"
        (change)="onChange(checked)"
        [matTooltip]="hint"
        [disabled]="disabled"
        matTooltipPosition="above"
      />
      <span>{{ labelText }}</span>
    </label>
  `,
})
export class XpInputCheckboxComponent implements OnInit, OnChanges, ControlValueAccessor {
  @Input() ngModel: any;
  @Output() ngModelChange = new EventEmitter<any>();
  @Input() hint: string = '';
  @Input() name: string = '';
  @Input() labelText: string = '';
  @Input() disabled: boolean = false;

  checked = false;

  firstChange = true;
  propagateChange = (_: any) => {};
  propagateTouch = () => {};

  ngOnInit() {
    this.onChange(this.ngModel);
  }

  ngOnChanges(changes) {
    if (changes.ngModel) {
      this.checked = !!changes.ngModel.currentValue;
    }
  }

  onChange(value) {
    this.ngModelChange.emit(value);
    this.propagateChange(value);
  }

  writeValue(value: any) {
    if (value !== undefined) {
      this.ngModel = value;
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn) {
    this.propagateTouch = fn;
  }
}
